export function integerToBinary(value: number, padding = 0): string {
	return value.toString(2).padStart(padding);
}

export function binaryToInteger(value: string): number {
	if (Number.isInteger(Number(value))) {
		return parseInt(value, 2);
	}

	return 0;
}
